/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import React, { Component } from 'react'
import styled from 'styled-components'
import widgetsService from 'live/services/widgets'
import Logger from 'live/services/logger'
import _ from 'lodash'
import SeriesService from 'live/services/charts/series'

export const NOT_AVAILABLE_PLACEHOLDER = 'N/A'
export const NOT_AVAILABLE_PLACEHOLDER_COLOR = '#ADBDD9'

export default class LiveChart extends Component {
    constructor(props) {
        super(props)
        this.elRef = React.createRef()
        this.lastEvents = {}
        this.following = {} // state of queries
        this.state = {
            hasData: true
        }
        this.activeFilters = props.activeFilters

        this.logger = new Logger('Live Chart (' + props.type + ')')
        this.refreshConfigurations = _.debounce(this.refreshConfigurations.bind(this), 500)
        this.ensureNoDataPlaceholder = _.debounce(this.ensureNoDataPlaceholder.bind(this), 600)
        this.renderPrefixSuffix = _.debounce(this.renderPrefixSuffix.bind(this), 600)
        this.renderFractionDigits = _.debounce(this.renderFractionDigits.bind(this), 600)
        this.renderSuffixPosition = _.debounce(this.renderSuffixPosition.bind(this), 600)
        this._cachedPlotLines = null
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getProperties = () => {
        const { type, layers, totalLayers, suffix, prefix, suffixBottom, fractionDigits } = this.props
        let properties = []
        if (layers) {
            for (let i = 0; i < totalLayers; i++) {
                if (layers.includes(i)) {
                    properties.push({
                        ...widgetsService.properties(type),
                        ...this.props.properties?.[i],
                        ...(type === 'value'
                            ? {
                                  suffix,
                                  prefix,
                                  suffixBottom,
                                  fractionDigits,
                                  maximumFractionDigits: fractionDigits,
                                  minimumFractionDigits: fractionDigits
                              }
                            : {})
                    })
                } else {
                    properties.push({})
                }
            }
        } else {
            properties = this.props.properties || []
        }

        return properties
    }

    // UNSAFE_componentWillUpdate(nextProps, nextState) {
    //   this.logger.debug('LiveChart willUpdate', _.isEqual(this.props, nextProps), this.props, nextProps)
    // }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    refreshConfigurations() {
        // Renders chart again according to new container's size
        // TODO: find a better way of doing this? Currently calling widget's recalc/render methods manually
        this.logger.debug('refreshConfigurations', this)

        const widget = this.liveWidget
        const type = this.props.type

        if (widget.reflow) {
            widget.reflow()
        } else if (widget?.chart?.reflow) {
            widget.chart.reflow()
        } else if (widget.state$) {
            if (type === 'value') {
                this.renderPrefixSuffix(this.props)
                this.renderFractionDigits(this.props)
                this.renderSuffixPosition(this.props)
            } else {
                this.renderOutput = widget.render(widget.state$.getValue(), widget.config$.getValue())
            }
        } else if (widget.render) {
            this.renderOutput = widget.render()
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    renderSuffixPosition(layerCfg) {
        if (!layerCfg) {
            return null
        }
        const widgetContent = this?.elRef?.current?.querySelector('#new-value-widget-content')

        if (widgetContent) {
            const suffixBottom = layerCfg.suffixBottom
            if (!suffixBottom) {
                widgetContent.style.flexDirection = 'row'
            } else {
                widgetContent.style.flexDirection = 'column'
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    renderPrefixSuffix(layerCfg) {
        if (!layerCfg?.prefix && !layerCfg?.suffix) {
            return null
        }
        const prefix = this?.elRef?.current?.querySelector('.prefix')
        const suffix = this?.elRef?.current?.querySelector('.suffix')

        if (prefix) {
            this.setState({
                prefix: this.props.prefix
            })
            // prefix.innerText = this.props.prefix
            // prefix.style.display = 'block'
        }

        if (suffix) {
            this.setState({
                suffix: this.props.suffix
            })
            // suffix.innerText = this.props.suffix
            // suffix.style.display = 'block'
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    renderFractionDigits(layerCfg) {
        if (layerCfg?.fractionDigits === undefined || layerCfg?.fractionDigits === null) {
            return null
        }
        const value = this?.elRef?.current?.querySelector('.value')

        if (value) {
            const updateDisplayedValue = displayValue => {
                if (this.state.value !== displayValue) {
                    this.setState({ value: displayValue })
                }
                if (value.innerText !== displayValue) {
                    value.innerText = displayValue
                }
            }

            const rawValue = value.innerText.trim()
            // If value contains letters, treat it as text and display as-is.
            if (/[a-zA-Z]/.test(rawValue)) {
                updateDisplayedValue(rawValue)
                return
            }

            // More flexible regex that captures any numeric string with separators
            const match = rawValue.match(/^([-+]?[\d.,]+)(.*)$/)

            if (match) {
                let numericStr = match[1]
                const unitPart = match[2]?.trim() || ''

                // Detect the thousand separator and decimal separator used
                let thousandSep = ''
                let decimalSep = '.'

                // Count separators to determine format
                const dotCount = (numericStr.match(/\./g) || []).length
                const commaCount = (numericStr.match(/,/g) || []).length

                // Normalize for parseFloat while remembering original format
                let normalizedStr = numericStr

                if (dotCount > 0 && commaCount > 0) {
                    // Both present: last one is decimal separator
                    const lastDot = numericStr.lastIndexOf('.')
                    const lastComma = numericStr.lastIndexOf(',')

                    if (lastComma > lastDot) {
                        // European format: 1.234.567,89
                        thousandSep = '.'
                        decimalSep = ','
                        normalizedStr = numericStr.replace(/\./g, '').replace(',', '.')
                    } else {
                        // US format: 1,234,567.89
                        thousandSep = ','
                        decimalSep = '.'
                        normalizedStr = numericStr.replace(/,/g, '')
                    }
                } else if (commaCount > 1) {
                    // Multiple commas = US thousand separator
                    thousandSep = ','
                    decimalSep = '.'
                    normalizedStr = numericStr.replace(/,/g, '')
                } else if (dotCount > 1) {
                    // Multiple dots = European thousand separator
                    thousandSep = '.'
                    decimalSep = ','
                    normalizedStr = numericStr.replace(/\./g, '')
                } else if (commaCount === 1 && !numericStr.includes('.')) {
                    // Single comma - assume decimal separator
                    decimalSep = ','
                    normalizedStr = numericStr.replace(',', '.')
                }
                // Single dot or no separators - use default (US format)

                const numericPart = parseFloat(normalizedStr)

                if (!isNaN(numericPart)) {
                    const fractionDigits = layerCfg.fractionDigits
                    let formattedNumber

                    if (fractionDigits === 0) {
                        formattedNumber = Math.trunc(numericPart).toString()
                    } else {
                        formattedNumber = numericPart.toFixed(fractionDigits)
                    }

                    // Re-apply thousand separators if they were present
                    if (thousandSep) {
                        const parts = formattedNumber.split('.')
                        const integerPart = parts[0]
                        const decimalPart = parts[1]

                        // Add thousand separators back
                        const withSeparators = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep)

                        // Reconstruct with correct decimal separator
                        formattedNumber = decimalPart ? `${withSeparators}${decimalSep}${decimalPart}` : withSeparators
                    }

                    const displayValue = `${formattedNumber} ${unitPart}`.trim()
                    updateDisplayedValue(displayValue)
                    return
                }
            }

            // Fallback: Display other unmatched values
            updateDisplayedValue(rawValue)
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    componentDidUpdate(prevProps) {
        const { activeFilters } = this.props
        if (!_.isEqual(activeFilters, prevProps.activeFilters)) {
            const chart = this.liveWidget?.chart

            // Clean all plotLines
            chart?.xAxis?.forEach(axis => axis.update({ plotLines: [] }, false))

            // add all plotLines again that were cached
            this?._cachedPlotLines?.forEach((plotLinesOpts, axisIdx) => {
                plotLinesOpts.forEach(opts => {
                    chart.xAxis[axisIdx].addPlotLine(opts)
                })
            })

            if (chart && typeof chart.redraw === 'function') {
                chart.redraw()
            }
        }
        // TODO: optimize with should update because this method seems to be called many times
        // Obs: right now this is debounced to try avoid a lot of cpu usage
        this.refreshConfigurations()
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    componentDidMount() {
        this.props.onReady()

        const type = this.props.type
        const properties = this.getProperties()
        const config = { ...(this.props.config || {}), properties }

        const LiveWidget = widgetsService.impl(type)
        this.liveWidget = new LiveWidget({
            el: this.elRef.current,
            cfg: config,
            dashboardTheme: this.props.dashboardTheme,
            onSelection: this.props.onSelection,
            onChangeUI: this.props.onChangeUI,
            reloadWidget: this.props.reloadWidget,
            dashboardContext: this.props.dashboardContext,
            widgetContext: this.props.widgetContext,
            onReady: this.props.onReady
        })

        if (this.liveWidget.setEl) {
            this.liveWidget.setEl(this.elRef.current)
        }

        if (this.liveWidget.state$) {
            this.renderOutput = this.liveWidget.render(
                this.liveWidget.state$.getValue(),
                this.liveWidget.config$.getValue()
            )
        } else {
            this.renderOutput = this.liveWidget.render()
        }

        this.renderedElement = null
        if (typeof this.renderOutput === 'function') {
            this.renderedElement = this.renderOutput()
            if (!this.renderedElement.props) {
                this.renderedElement = null
            }
        }

        // Cache plotLines options
        this._cachedPlotLines = this.liveWidget.chart?.xAxis.map(axis =>
            (axis.options.plotLines || []).map(opt => ({ ...opt }))
        )
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    highchartsHasData = () => {
        if (this.liveWidget && this.liveWidget.chart && this.liveWidget.chart.series) {
            return this.liveWidget.chart.series.some(s => s.dataMax !== undefined && s.dataMin !== undefined)
        }

        return false
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ensureNoDataPlaceholder = () => {
        if (this.props.type === 'temporal') {
            const allEndedHistory = Object.keys(this.following).every(layer => this.following[layer])
            if (!allEndedHistory) {
                // schedule again (via debounce)
                this.ensureNoDataPlaceholder()

                return
            }

            const hasData =
                this.highchartsHasData() || Object.values(this.lastEvents).some(x => x && Object.keys(x).length > 0)
            if (hasData !== this.state.hasData) {
                this.logger.info('Updating hasData to:', hasData)
                this.setState({ hasData })
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    flow = (type, events, layer) => {
        if (type === 'endHistory') {
            this.following[layer] = true
        }

        if (type === 'start') {
            this.lastEvents[layer] = null
            this.following[layer] = false
        }

        if (events && type === 'event') {
            this.lastEvents[layer] = events
            this.ensureNoDataPlaceholder()
        }

        // only forward events given props
        const props = this.props
        const eventForThisLayer =
            (!props.layers && !props.layersExcept) ||
            (props.layers && props.layers.includes(layer)) ||
            (props.layersExcept && !props.layersExcept.includes(layer))

        if (!eventForThisLayer) {
            return
        }
        this.liveWidget.flow(type, events, layer)
        if (this.props.type === 'value') {
            this.renderPrefixSuffix(props)
            this.renderFractionDigits(props)
            this.renderSuffixPosition(props)
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    render() {
        const { hasData, prefix, suffix, value } = this.state
        const { suffixBottom } = this.props.cfg

        const extraStyles = hasData && {
            display: 'flex',
            justifyContent: 'center'
        }

        return (
            <>
                <NoDataFound style={{ display: hasData ? 'none' : 'flex' }}>
                    No data found in the selected period
                </NoDataFound>

                {/* Workaround, should be revised, this is to avoid the re-rendering */}
                {this.props.type === 'value' ? (
                    <div
                        id={'new-value-widget-content'}
                        className={this.props.className}
                        style={{
                            ...this.props.style,
                            ...extraStyles
                        }}
                        ref={this.elRef}
                    >
                        <div className={'value-widget'}>
                            <div
                                id={'value-widget-content'}
                                style={{
                                    display: 'flex',
                                    gap: 5,
                                    fontSize: 25,
                                    flexDirection: suffixBottom ? 'column' : 'row',
                                    height: suffixBottom ? 100 : 'auto',
                                    justifyContent: suffixBottom ? 'space-evenly' : 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '2vh'
                                    }}
                                >
                                    {prefix}
                                </span>
                                <span>{value}</span>
                                <span
                                    style={{
                                        fontSize: '2vh'
                                    }}
                                >
                                    {suffix}
                                </span>
                            </div>
                        </div>
                        <div style={{ display: 'none' }}>{this.renderedElement}</div>
                    </div>
                ) : (
                    <div
                        className={this.props.className}
                        style={{
                            ...this.props.style,
                            ...extraStyles
                        }}
                        ref={this.elRef}
                    >
                        {this.renderedElement}
                    </div>
                )}
            </>
        )
    }
}

const NoDataFound = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    line-height: 1.75rem;
    height: 100%;
`
